// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"09e554b5","572":"ef092d72"}[chunkId] + ".chunk.js";
};